import React from 'react';
import { useLocation, useNavigate, Outlet, Link } from 'react-router-dom';
import { Avatar, Dropdown } from 'antd';
import { UserOutlined, ExportOutlined } from '@ant-design/icons';
import { useAuth } from '../../auth/AuthContext';
import logo from '../../assets/logo.png';
import './index.css';

const navLinks = [
  { path: '/portal', label: '首页', exact: true },
  { path: '/portal/admission-progress', label: '准入进度', forNonMain: true },
  { path: '/portal/info', label: '信息维护' },
  { path: '/portal/evaluation', label: '评价查询' },
  { path: '/portal/objection', label: '异议反馈' },
];

const PortalLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const userMenuItems = [
    {
      key: 'logout',
      icon: <ExportOutlined />,
      label: '退出登录',
    },
  ];

  const handleUserMenu = ({ key }) => {
    if (key === 'logout') {
      logout();
      navigate('/login');
    }
  };

  return (
    <div className="portal-layout">
      <header className="portal-header">
        <div className="portal-header-inner">
          <Link to="/portal" className="portal-logo">
            <img src={logo} alt="中国资源循环集团" className="portal-logo-img" />
            <span className="portal-logo-divider">|</span>
            <span className="portal-logo-subtitle">供应商自助服务平台</span>
          </Link>
          <nav className="portal-nav">
            {navLinks.filter((link) => !link.forNonMain || user?.businessType !== 'main').map((link) => {
              const isActive = link.exact
                ? location.pathname === link.path
                : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`portal-nav-link ${isActive ? 'portal-nav-link-active' : ''}`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
          <div className="portal-user">
            <Dropdown
              menu={{ items: userMenuItems, onClick: handleUserMenu }}
              placement="bottomRight"
            >
              <div className="portal-user-info">
                <Avatar size={30} icon={<UserOutlined />} className="portal-avatar" />
                <span className="portal-user-name">{user?.name || '供应商'}</span>
              </div>
            </Dropdown>
          </div>
        </div>
      </header>
      <main className="portal-content">
        <Outlet />
      </main>
      <footer className="portal-footer">
        <div className="portal-footer-inner">
          <span>&copy; 2026 中国资源循环集团有限公司</span>
        </div>
      </footer>
    </div>
  );
};

export default PortalLayout;
